"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.measurementsSystemWithDefaultUnits = void 0;
const graphql_1 = require("../../../graphql");
/**
 * Variable to store default units for mass, volume, and calf weight according to the
 * measurement system.
 */
exports.measurementsSystemWithDefaultUnits = {
    [graphql_1.Enum_Measurement_System_Enum.UsCustomary]: {
        defaultMassUnit: 'lb',
        defaultVolumeUnit: 'qt',
        defaultCalfWtUnit: 'lb',
    },
    [graphql_1.Enum_Measurement_System_Enum.Metric]: {
        defaultMassUnit: 'g',
        defaultVolumeUnit: 'L',
        defaultCalfWtUnit: 'kg',
    },
};
exports.default = exports.measurementsSystemWithDefaultUnits;
//# sourceMappingURL=measurementsSystemWithDefaultUnits.js.map